import { Fragment, type ReactNode } from 'react';

/**
 * Lets a code like `risk_signal.ssn_does_not_match` wrap after its underscores and dots instead of mid-word.
 * `<wbr>` adds no characters, so copying the code still copies it exactly.
 */
const breakAtSeparators = (code: string): ReactNode => {
  let offset = 0;
  return code.split(/(?<=[._])/).map(part => {
    const key = offset;
    offset += part.length;
    return (
      <Fragment key={key}>
        {key > 0 && <wbr />}
        {part}
      </Fragment>
    );
  });
};

export default breakAtSeparators;
